import { AfterViewInit, Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Group } from 'app/models/recipe.model';
import { IngrediantService } from 'app/services/ingrediant.service';

@Component({
	selector: 'food-items-list',
	templateUrl: './food-items-list.component.html',
	styleUrls: ['food-items-list.component.scss']
})
export class FoodItemsListComponent implements OnInit, AfterViewInit{
	pageLoaded = false;
	filterText = "";
	@Output("itemSelected") itemSelected: EventEmitter<any> = new EventEmitter();
	
	constructor(
		private _ingrediantService: IngrediantService
	) {

	}

	selectItem = (item: Group) => {
		if (!item.items || item.items.length == 0)
			this.itemSelected.emit(item);
	}
		

	ngAfterViewInit(): void {
		
	}

	private ids: any = {};
	data: Group[] = [];
	ngOnInit() {
		this._ingrediantService.getAll().subscribe((res) => {
			this.data = res;
			// this.data.forEach((e) => {
			// 	e.items.forEach((d) => {
			// 		// console.log("\""+d.id+"\": \""+d.id+"\",");
			// 		// console.log(d.Recommendation_on_Sustainability_and_Nutritional)
			// 		if (this.ids[d.uuid]) {
			// 			console.log("Found duplicate for " , d);
			// 			console.log("Original: ", this.ids[d.uuid]);
						
			// 		}
			// 		else {
			// 			this.ids[d.uuid] = d;
			// 		}
			// 	})
				
			// 	e.subgroups.forEach((subgroup) => {
			// 		subgroup.items.forEach((item_s) => {
			// 			if (this.ids[item_s.uuid]) {
			// 				console.log("Found duplicate for " , item_s);
			// 				console.log("Original: ", this.ids[item_s.uuid]);
							
			// 			}
			// 			else {
			// 				this.ids[item_s.uuid] = item_s;
			// 			}
			// 		})

			// 		// subgroup.subgroups.forEach((di) => {
			// 		// 	// console.log("\""+di.id+"\": \""+di.id+"\",");
			// 		// 	di.items.forEach((item) => {
			// 		// 		if (this.ids[item.uuid]) {
			// 		// 			console.log("Found duplicate for " , item);
			// 		// 			console.log("Original: ", this.ids[item.uuid]);
								
			// 		// 		}
			// 		// 		else {
			// 		// 			this.ids[item.uuid] = item;
			// 		// 		}
			// 		// 	})

			// 		// 	if (this.ids[di.uuid]) {
			// 		// 		console.log("Found duplicate for " , di);
			// 		// 		console.log("Original: ", this.ids[di.uuid]);
							
			// 		// 	}
			// 		// 	else {
			// 		// 		this.ids[di.uuid] = di;
			// 		// 	}
			// 		// })

			// 	})
			// })
			// let n = 0;
			// for (let key in this.ids) n++;
			// console.log("items loaded. n: " + n );
			this.pageLoaded = true;

		})
		

		// console.log(this.data);
		

		// this.pageLoaded = true;
	}

	
}